import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { captureException, capturePageLeave, initializePostHog, registerPostHogUserBridge } from '@/analytics/posthog';

const app = createApp(App);

initializePostHog();
registerPostHogUserBridge();

app.config.errorHandler = (err, _instance, info) => {
    if (import.meta.env.DEV) {
        console.error('Vue errorHandler caught:', err, info);
    }

    captureException(err, {
        source: 'vue.errorHandler',
        info,
    });
};

app.use(router);
window.vueRouter = router;

window.addEventListener('pagehide', () => {
    capturePageLeave(router.currentRoute.value.fullPath);
});

app.mount('#vue-app');
